<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4></h4>
    <hr>
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
            </button>
          </td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
            </button>
          </td>
          <td>
            <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
              <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Código</th>
          <th scope="col">Descripción</th>
          <th scope="col">Cantidad</th>
          <th scope="col">Valor Uni</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
         v-for="planilladet in datosPaginados"
         :key="planilladet.idPlanillaDet"
         @dblclick="handleRowClick($event, planilladet.idPlanillaDet)"
         >
          <td>{{planilladet.elementoCodigo}}</td>
          <td>{{planilladet.elementoNombre}}</td>
          <td>{{planilladet.cantidad}}</td>
          <td>{{planilladet.valorUni}}</td>
          <td>{{planilladet.valorTotal}}</td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" @click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li v-for="pagina in totalPaginas()" :key="pagina" @click="getDataPaginaTodos(pagina)" class="page-item" :class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" @click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{titulo}}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">
              <!-- Elemento con búsqueda mejorada -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="searchElemento" class="form-label fw-bold">Elemento</label>
                  </div>
                  <div class="col-10 position-relative">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="material-icons" style="font-size:20px;">search</i>
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        id="searchElemento"
                        v-model="searchElemento"
                        @input="buscarElementos"
                        @focus="mostrarListaElementos = true"
                        @blur="ocultarListaDelay"
                        placeholder="Escriba código o nombre del elemento (mín. 2 caracteres)..."
                        autocomplete="off"
                        required
                      />
                      <button 
                        v-if="searchElemento" 
                        class="btn btn-outline-secondary" 
                        type="button"
                        @click="limpiarBusqueda"
                      >
                        <i class="material-icons" style="font-size:18px;">clear</i>
                      </button>
                    </div>
                    
                    <!-- Loading indicator -->
                    <div v-if="cargandoElementos" class="text-center mt-2">
                      <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="visually-hidden">Buscando...</span>
                      </div>
                      <small class="text-muted ms-2">Buscando elementos...</small>
                    </div>

                    <!-- Información del elemento seleccionado -->
                    <div v-if="datoPlanillaDet.idElemento && !mostrarListaElementos" class="elemento-seleccionado mt-2 p-3 border rounded bg-light">
                      <div class="row">
                        <div class="col-md-3">
                          <small class="text-muted d-block">Código:</small>
                          <strong class="text-primary">{{ datoPlanillaDet.elementoCodigo }}</strong>
                        </div>
                        <div class="col-md-6">
                          <small class="text-muted d-block">Descripción:</small>
                          <strong>{{ datoPlanillaDet.elementoNombre }}</strong>
                        </div>
                        <div class="col-md-3">
                          <small class="text-muted d-block">Tarifa:</small>
                          <strong class="text-success">${{ formatearPrecio(elementoSeleccionadoCompleto?.valor) }}</strong>
                          <small class="d-block text-muted">{{ elementoSeleccionadoCompleto?.tarifaConvNombre }}</small>
                        </div>
                      </div>
                    </div>

                    <!-- Lista desplegable de resultados mejorada -->
                    <div
                      v-if="mostrarListaElementos && elementosFiltrados.length > 0"
                      class="list-group position-absolute w-100 mt-1 shadow-lg"
                      style="max-height: 400px; overflow-y: auto; z-index: 1050; border-radius: 8px;"
                    >
                      <div class="list-group-item bg-primary text-white py-2">
                        <small>
                          <strong>{{ elementosFiltrados.length }}</strong> resultado(s) encontrado(s)
                        </small>
                      </div>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action elemento-item"
                        v-for="elem in elementosFiltrados"
                        :key="elem.idTarifaPres"
                        @mousedown.prevent="seleccionarElemento(elem)"
                      >
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center mb-1">
                              <span class="badge bg-primary me-2">{{ elem.elementoCodigo }}</span>
                              <span class="badge bg-info text-dark">{{ elem.tarifaConvNombre }}</span>
                            </div>
                            <div class="elemento-nombre">
                              {{ elem.elementoNombre }}
                            </div>
                          </div>
                          <div class="text-end ms-3">
                            <div class="precio-elemento">
                              ${{ formatearPrecio(elem.valor) }}
                            </div>
                            <small class="text-muted d-block">ID: {{ elem.idElemento }}</small>
                          </div>
                        </div>
                      </button>
                    </div>

                    <!-- Mensaje cuando no hay resultados -->
                    <div 
                      v-if="mostrarListaElementos && elementosFiltrados.length === 0 && searchElemento.length >= 2 && !cargandoElementos"
                      class="alert alert-warning mt-2"
                    >
                      <i class="material-icons" style="font-size:18px; vertical-align: middle;">info</i>
                      No se encontraron elementos que coincidan con "<strong>{{ searchElemento }}</strong>"
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label for="cantidad" class="form-label">Cantidad</label>
                  </div>
                  <div class="col-3">
                    <input 
                      type="number" 
                      class="form-control" 
                      id="cantidad" 
                      v-model="datoPlanillaDet.cantidad"
                      @input="calcularTotal"
                      min="1"
                      step="1"
                      required
                    >
                  </div>
                  <div class="col-3">
                    <label for="valorUni" class="form-label">Valor Unitario</label>
                  </div>
                  <div class="col-3">
                    <input 
                      type="number" 
                      class="form-control" 
                      id="valorUni" 
                      v-model="datoPlanillaDet.valorUni"
                      @input="calcularTotal"
                      step="0.01"
                      required
                    >
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label for="fechaAtencion" class="form-label">Fecha de Atención</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaAtencion"
                      name="fechaAtencion"
                      v-model="datoPlanillaDet.fechaAtencion"
                      :min="getFormattedDateISO(p_fechaDesde)"
                      :max="getFormattedDateISO(p_fechaHasta)"
                    />
                  </div>
                  <div class="col-3">
                    <label for="valorTotal" class="form-label">Valor Total</label>
                  </div>
                  <div class="col-3">
                    <input 
                      type="text" 
                      class="form-control fw-bold text-success" 
                      id="valorTotal" 
                      v-model="valorTotalFormateado" 
                      disabled
                    >
                  </div>
                </div>
              </div>			  
            </div>
          </form>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="guardarPlanillaDet" v-if="btnCrear" title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button type="button" class="btn btn-light" @click="guardarEditPlanillaDet" v-if="btnEditar" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import api from "@/services/api";
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import dateFormat from "@/modules/dateFormat.js";
import { validarForm } from '../../modules/validacionesForms.js';
import swal from 'sweetalert';
import * as bootstrap from 'bootstrap';

export default {
  props: {
    p_tipoElemento: {
      type: String,
      required: true,
    },  
    p_idPrestador: {
      type: Number,
      required: true,
    },
    p_idPlanilla: {
      type: Number,
      required: false
    },
    p_idClasElem: {
      type: Number,
      required: false
    },
    p_fechaDesde: {
      type: Date,
      required: true,
    },
    p_fechaHasta: {
      type: Date,
      required: true,
    },
  },
  components: { Layout, Footer },
  data() {
    return {
      planilladets: [],
      datoPlanillaDet: {
        idPlanillaDet: null,
        idPlanilla: null,
        idElemento: null,
        elementoCodigo: '',
        elementoNombre: '',
        descripcion: '',
        cantidad: 1,
        valorUni: 0,
        valorTotal: 0,
        fechaAtencion: null
      },
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      searchElemento: '',
      elementosFiltrados: [],
      mostrarListaElementos: false,
      debounceTimer: null,
      cargandoElementos: false,
      elementoSeleccionadoCompleto: null
    };
  },
  computed: {
    valorTotalFormateado() {
      return '$' + this.formatearPrecio(this.datoPlanillaDet.valorTotal);
    }
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    formatearPrecio(valor) {
      if (!valor) return '0.00';
      return parseFloat(valor).toFixed(2);
    },
    calcularTotal() {
      const cantidad = parseFloat(this.datoPlanillaDet.cantidad) || 0;
      const valorUni = parseFloat(this.datoPlanillaDet.valorUni) || 0;
      this.datoPlanillaDet.valorTotal = cantidad * valorUni;
    },
    limpiarBusqueda() {
      this.searchElemento = '';
      this.elementosFiltrados = [];
      this.datoPlanillaDet.idElemento = null;
      this.datoPlanillaDet.elementoCodigo = '';
      this.datoPlanillaDet.elementoNombre = '';
      this.datoPlanillaDet.valorUni = 0;
      this.elementoSeleccionadoCompleto = null;
      this.calcularTotal();
    },
    getFormattedDateISO(date) {
      return dateFormat.getFormattedDateISO(date);
    },
    handleRowClick(event, idPlanillaDet) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirModalEditar(idPlanillaDet);
    },
    totalPaginas() {
      return Math.ceil(this.planilladets.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get(`/vwplanilladets/idplanilla-clasificacion/${this.p_idPlanilla}/${this.p_idClasElem}`).then(response => {
        this.planilladets = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.planilladets.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.paginaActual--;
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.paginaActual++;
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? 'active' : '';
    },
    validarForm() {
      const requiredFields = ['idPlanilla', 'idElemento', 'cantidad', 'valorUni'];
      return validarForm(this.datoPlanillaDet, requiredFields, requiredFields);
    },
    async guardarPlanillaDet() {
      this.datoPlanillaDet.idPlanilla = this.p_idPlanilla;
      if (this.validarForm() === 1) {
        try {
          await api.post('/planilladets', this.datoPlanillaDet);
          this.cerrarModal();
          swal("Correcto!", "PlanillaDet creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlanillaDet() {
      if (this.validarForm() === 1) {
        try {
          await api.post(`/planilladets`, this.datoPlanillaDet);
          this.cerrarModal();
          swal("Correcto!", "PlanillaDet actualizada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
    abrirModalCrear() {
      this.datoPlanillaDet = {
        idPlanilla: null,
        idElemento: null,
        elementoCodigo: '',
        elementoNombre: '',
        descripcion: '',
        cantidad: 1,
        valorUni: 0,
        valorTotal: 0,
        fechaAtencion: null
      };
      this.searchElemento = '';
      this.elementosFiltrados = [];
      this.elementoSeleccionadoCompleto = null;
      this.titulo = 'Crear ';
      this.btnCrear = true;
      this.btnEditar = false;
    },
    async abrirModalEditar(idPlanillaDet) {
      if (idPlanillaDet) {	
        await api.get("/vwplanilladets/" + idPlanillaDet).then((resp) => {
          this.datoPlanillaDet = resp.data;
          this.searchElemento = this.datoPlanillaDet.elementoCodigo + ' - ' + this.datoPlanillaDet.elementoNombre || '';
        });
      }
      this.titulo = 'Editar ';
      this.btnCrear = false;
      this.btnEditar = true;
      if (this.datoPlanillaDet.fechaAtencion) {
        this.datoPlanillaDet.fechaAtencion = this.getFormattedDateISO(
          this.datoPlanillaDet.fechaAtencion
        );
      }
      this.$nextTick(() => {
        const modalElement = document.getElementById("ventanaModal");
        if (modalElement) {
          this.modalInstance = new bootstrap.Modal(modalElement, { backdrop: true });
          this.modalInstance.show();
          modalElement.addEventListener("hidden.bs.modal", this.onModalHidden);
        }
      });
    },
    async deletePlanillaDet(idPlanillaDet) {
      if (confirm('¿Estás seguro de eliminar este registro?')) {
        try {
          await api.delete('/planilladets/' + idPlanillaDet);
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "No se pudo eliminar", "error");
        }
      }
    },
    buscarElementos() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        if (this.searchElemento.trim().length >= 2) {
          this.fetchElementosFiltrados();
        } else {
          this.elementosFiltrados = [];
        }
      }, 400);
    },
    async fetchElementosFiltrados() {
      let p_idPrestadorSeleccionado;
      if (this.p_tipoElemento === 'procedimientos') {
        p_idPrestadorSeleccionado = this.p_idPrestador;
      } else if (this.p_tipoElemento === 'medicamentos') {
        p_idPrestadorSeleccionado = 10;
      } else if (this.p_tipoElemento === 'insumos') {
        p_idPrestadorSeleccionado = 11;
      } else {
        p_idPrestadorSeleccionado = 0;
      }
      
      this.cargandoElementos = true;
      try {
        const response = await api.get(`/vwtarifapress/search-prestador?idprestador=${p_idPrestadorSeleccionado}&search=${this.searchElemento}`);
        this.elementosFiltrados = response.data;
      } catch (error) {
        console.error('Error al buscar elementos:', error);
        this.elementosFiltrados = [];
      } finally {
        this.cargandoElementos = false;
      }
    },
    seleccionarElemento(elem) {
      this.datoPlanillaDet.idElemento = elem.idElemento;
      this.datoPlanillaDet.elementoCodigo = elem.elementoCodigo;
      this.datoPlanillaDet.elementoNombre = elem.elementoNombre;
      this.datoPlanillaDet.valorUni = elem.valor;
      this.elementoSeleccionadoCompleto = elem;
      this.searchElemento = `${elem.elementoCodigo} - ${elem.elementoNombre}`;
      this.mostrarListaElementos = false;
      this.calcularTotal();
    },
    ocultarListaDelay() {
      setTimeout(() => {
        this.mostrarListaElementos = false;
      }, 200);
    },
    cerrarModal() {
      const modal = document.getElementById('ventanaModal');
      const bsModal = bootstrap.Modal.getInstance(modal);
      if (bsModal) bsModal.hide();
    }
  },
};
</script>

<style scoped>
.elemento-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.elemento-item:hover {
  background-color: #f8f9fa;
  border-left-color: #0d6efd;
  transform: translateX(2px);
}

.elemento-nombre {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}

.precio-elemento {
  font-size: 18px;
  font-weight: bold;
  color: #198754;
}

.elemento-seleccionado {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

.list-group {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.badge {
  font-size: 11px;
  padding: 4px 8px;
}
</style>